<div class="c-content c-content--wrapper u-no-p" [ngStyle]="vm.loading && {'min-height': '300px'}">
	<div *ngIf="!vm.loading">
		<div class="c-content u-no-ph@md-and-up u-hidden@up-to-md">
			<div class="o-grid o-grid--center-v">
				<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-33@lg-and-up u-no-p o-grid__cell--left">
					<form class="c-form">
						<div class="o-grid">
							<div class="o-grid__cell o-grid__cell--slim">
								<div class="c-form__group u-osb-sm">
									<label class="c-checkbox">
										<input type="checkbox" [(ngModel)]="vm.showAdditionalInfo" name="showAdditionalInfo">
										<span id="showAdditionalInfoLabel">{{ 'Employees.Show_Additional_Info' | translate }}</span>
									</label>
								</div>
							</div>
							<div class="o-grid__cell o-grid__cell--slim" *ngIf="vm.hasInsurance()">
								<div class="c-form__group u-osb-sm">
									<label class="c-checkbox">
										<input type="checkbox" [(ngModel)]="vm.includeInsurance" name="includeInsurance" (change)="vm.toggledIncludeInsurance()">
										<span id="showInsuranceInfoLabel">{{ 'Employees.Include_Insurance' | translate }}</span>
									</label>
								</div>
							</div>
						</div>
					</form>
				</div>
				<div class="o-grid__cell o-grid__cell--w-45 o-grid__cell--w-33@lg-and-up u-no-p o-grid__cell--right">
					<form class="c-form">
						<div class="o-grid">
							<div class="o-grid__cell o-grid__cell--slim">
								<div class="c-form__group c-form__group--icon u-osb-sm">
									<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
									<input id="searchEmployeeInput" name="searchEmployeeInput" type="text" class="c-form__input c-form__input--sm" placeholder="{{ 'Employees.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.term" (ngModelChange)="onSearchChange($event)">
								</div>
							</div>
							<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-fixed u-no-p">
								<a id="downloadEmployeeReportLink" href="{{vm.xlsDownloadUrl}}" target="_self" download="user-report.xls" class="c-button c-button--s1 c-button--fit">{{ 'Common.Download' | translate }}</a>
							</div>
						</div>
					</form>
				</div>
				<div class="o-grid__cell o-grid__cell--w-5 o-grid__cell--w-5@lg-and-up o-grid__cell--center" *ngIf="vm.businessServiceSetting?.enableActivationReminder || vm.businessServiceSetting?.enableSessionLimitReminder">
					<div class="burger-menu">
						<div class="burger-icon" (click)="vm.toggleBurgerMenu()" [ngStyle]="!vm.businessServiceSetting?.hasSeenGuide && { 'margin-top': '10px' }">
							<div class="line"></div>
							<div class="line"></div>
							<div class="line"></div>
						</div>
					</div>
					<guide-info-popover placement="bottom"
										placementMobile="bottom"
										[wrapperMobile]="vm.popoverMobileWrapper"
										[businessServiceSetting]="vm.businessServiceSetting"
										(click)="$event.preventDefault()"
										style="vertical-align:middle" class="u-osl-xs"
										*ngIf="!vm.businessServiceSetting?.hasSeenGuide">
					</guide-info-popover>
				</div>
			</div>
		</div>
		<div class="c-content c-content--border-bottom u-no-ph@md-and-up u-hidden@up-to-md">
			<div class="o-grid o-grid--wrap">
				<div class="o-grid__cell o-grid__cell--w-15 u-no-p">
					<a id="createdFilterLink" href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('created')" aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Invited_Date' | translate }}</span>&nbsp;<span *ngIf="vm.filter?.orderBy==='created' && vm.filter?.ascending">&#8595;</span><span *ngIf="vm.filter?.orderBy==='created' && !vm.filter?.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-25 u-no-p">
					<a id="nameFilterLink" href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('name')" aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Name' | translate }}</span>&nbsp;<span *ngIf="vm.filter?.orderBy==='name' && vm.filter?.ascending">&#8595;</span><span *ngIf="vm.filter?.orderBy==='name' && !vm.filter?.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-30 u-no-p">
					<a id="emailFilterLink" href="javascript:void(0)" class="c-text c-text--gray" (click)="vm.setFilter('email')" aria-hidden="true"><span style="vertical-align:middle">{{ 'Employees.Email' | translate }}</span>&nbsp;<span *ngIf="vm.filter?.orderBy==='email' && vm.filter?.ascending">&#8595;</span><span *ngIf="vm.filter?.orderBy==='email' && !vm.filter?.ascending">&#8593;</span></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-10 u-no-p">
					<span class="c-text c-text--gray" style="vertical-align:middle">{{ 'Employees.Status' | translate }}</span>
				</div>
			</div>
		</div>
		<ul class="c-list">
			<li *ngFor="let employee of vm.employees | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $index=index">
				<div class="c-content c-content--border-bottom u-no-ph@md-and-up" [hidden]="employee.deleted">
					<div id="employee-action-element-{{employee.id}}" class="o-grid o-grid--wrap@up-to-md">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-15@md-and-up u-no-p">
							<span class="u-hidden@md-and-up">{{ 'Employees.Invited_Date' | translate }}:</span>
							<p class="c-text c-text--sm@up-to-md c-text--s10">{{ employee.created | date:'dd.MM.yyyy' }}<span class="u-hidden@up-to-md"> {{ employee.created | date:'HH:mm:ss' }}</span></p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-no-p o-grid__cell--o2@md-and-up u-ost-md@up-to-md">
							<span class="u-hidden@md-and-up">{{ 'Employees.Status' | translate }}:</span>
							<p class="c-text c-text--sm@up-to-md c-text--s10">{{ vm.getEmployeeStatus(employee) }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-25@md-and-up u-no-p o-grid__cell--o1@md-and-up u-ost-md@up-to-md">
							<span class="u-hidden@md-and-up">{{ 'Employees.Name' | translate }}:</span>
							<p class="c-text c-text--sm@up-to-md c-text--s10">{{ employee.firstName }} {{ employee.lastName }} {{ employee.personalCode ? '(' + employee.personalCode + ')' : ''}}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-30@md-and-up u-no-p o-grid__cell--o1@md-and-up u-ost-md@up-to-md">
							<span class="u-hidden@md-and-up">{{ 'Employees.Email' | translate }}:</span>
							<p id="employeeEmail{{$index}}" style="word-break: break-all;" class="c-text c-text--sm@up-to-md c-text--s10">{{ employee.email }}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-30@md-and-up o-grid__cell--w-fixed@md-and-up u-no-p o-grid__cell--o3@md-and-up o-grid__cell--right u-ost-md@up-to-md">
							<p class="c-text c-text--right" *ngIf="employee.accepted && employee.worker?.active">
								<a id="updateInsuranceButton" *ngIf="vm.canUserManuallyAddInsurance" href="javascript:void(0)" class="c-text c-text--uppercase c-text--bold" [ngClass]="{'u-opaque': employee.processing}" (click)="vm.updateInsurance(employee)">{{ 'Insurance.Title' | translate }}</a>
								<a id="deactivateEmployeeButton" href="javascript:void(0)" class="c-text c-text--uppercase c-text--bold u-osl-md" [ngClass]="{'u-opaque': employee.processing}" (click)="vm.toggleActiveStatus(employee)">{{ 'Employees.Button_Deactivate' | translate }}</a>
							</p>
							<p class="c-text c-text--right" *ngIf="!employee.accepted && !employee.worker?.active">
								<a id="deleteInvitationButton" href="javascript:void(0)" class="c-text c-text--uppercase c-text--bold" [ngClass]="{'u-opaque': employee.processing}" (click)="vm.deleteInvitation(employee)">{{ 'Employees.Button_Delete_Invitation' | translate }}</a>
							</p>
						</div>
					</div>
					<div class="o-grid o-grid--wrap u-ost-sm" *ngIf="vm.showAdditionalInfo">
						<div class="o-grid__cell o-grid__cell--w-60 u-no-p u-ost-md@up-to-md o-grid--wrap">
							<p *ngIf="employee.additionalInfo" class="c-text c-text--sm@up-to-md c-text--s10">
								<span id="currentAdditionalInfoLabel">{{ employee.additionalInfo }}</span>
								<i id="editAdditionalInfoButton" (click)="vm.editAdditionalInfo(employee)" class="o-icon o-icon--edit u-no-mr c-text c-text--sm c-text--main" style="cursor:pointer;padding-left:5px;line-height:1" aria-hidden="true"></i>
							</p>
							<p *ngIf="!employee.additionalInfo" class="c-text c-text--gray c-text--sm@up-to-md c-text--s10">
								<i id="noAdditionalInfoLabel">{{ 'Employees.Placeholder.AdditionalInfoMissing' | translate }}</i>
								<i id="editAdditionalInfoButton" (click)="vm.editAdditionalInfo(employee)" class="o-icon o-icon--edit u-no-mr c-text c-text--sm c-text--main" style="cursor:pointer;padding-left:5px;line-height:1" aria-hidden="true"></i>
							</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-40 o-grid__cell--w-fixed@md-and-up u-no-p o-grid__cell--o3@md-and-up o-grid__cell--right u-ost-md@up-to-md">
                            <p class="c-text c-text--right" *ngIf="employee.accepted && employee.worker?.active">
                               <a id="updateAdminAssistantButton{{$index}}" href="javascript:void(0)" class="c-text c-text--uppercase c-text--bold u-osl-md" [ngClass]="{'u-opaque': employee.processing}" (click)="vm.toggleAdminAssistantStatus(employee)">{{ ( employee.worker?.adminAssistantRights ? 'Employees.Disable_Admin_Assistant' : 'Employees.Enable_Admin_Assistant') | translate }}</a>
                            </p>
                        </div>
					</div>
					<div class="o-grid o-grid--wrap u-ost-sm" *ngIf="vm.showAdditionalInfo">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p u-ost-md@up-to-md o-grid--wrap">
							<p *ngIf="employee.additionalInfo2" class="c-text c-text--sm@up-to-md c-text--s10">
								<span id="currentAdditionalInfo2Label">{{ employee.additionalInfo2 }}</span>
								<i id="editAdditionalInfo2Button" (click)="vm.editAdditionalInfo2(employee)" class="o-icon o-icon--edit u-no-mr c-text c-text--sm c-text--main" style="cursor:pointer;padding-left:5px;line-height:1" aria-hidden="true"></i>
							</p>
							<p *ngIf="!employee.additionalInfo2" class="c-text c-text--gray c-text--sm@up-to-md c-text--s10">
								<i id="noAdditionalInfo2Label">{{ 'Employees.Placeholder.AdditionalInfoMissing' | translate }}</i>
								<i id="editAdditionalInfo2Button" (click)="vm.editAdditionalInfo2(employee)" class="o-icon o-icon--edit u-no-mr c-text c-text--sm c-text--main" style="cursor:pointer;padding-left:5px;line-height:1" aria-hidden="true"></i>
							</p>
						</div>
					</div>
					<div class="o-grid o-grid--wrap u-ost-sm" *ngIf="vm.includeInsurance && employee.insuranceWallets">
						<div class="o-grid__cell o-grid__cell--w-100 u-no-p u-ost-md@up-to-md o-grid--wrap">
							<span class="u-osb-sm c-text--bold">{{ 'Employees.Insurances' | translate }}:</span>
							<p *ngFor="let wallet of employee.insuranceWallets" style="padding-top:5px;" class="c-text c-text--sm@up-to-md c-text--s10">{{ wallet.policy.policyNumber }}{{ wallet.policy.purchasedPackage.insurerName ? ', ' + wallet.policy.purchasedPackage.insurerName : '' }} {{ wallet.policy.purchasedPackage.actualInsuranceProvider ? '(' + wallet.policy.purchasedPackage.actualInsuranceProvider + ')' : ''}}, {{ wallet.validFrom | date:'dd.MM.yyyy' }} - {{ wallet.validTo | date:'dd.MM.yyyy' }}
							    <a id="deactivatePolicyUserButton" *ngIf="!wallet.deactivated" href="javascript:void(0)" class="c-text c-text--uppercase c-text--bold u-osl-md" [ngClass]="{'u-opaque': employee.processing}" (click)="vm.deactivatePolicy(wallet, wallet.policy, employee)">{{ 'Business_Client_Policy_User.Deactivate' | translate }}</a>
							</p>
						</div>
					</div>
				</div>
			</li>
		</ul>
		<item-no-content *ngIf="!vm.employees?.length"></item-no-content>
	</div>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
